import { render, staticRenderFns } from "./FailedLoginTemplate.vue?vue&type=template&id=2971c5e2&"
import script from "./FailedLoginTemplate.vue?vue&type=script&lang=js&"
export * from "./FailedLoginTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports